import React from 'react';
import { Button, useTheme } from '@mui/material';

import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { STATUS_REFUSED, STATUS_VALID } from '@europrocurement/l2d-modules/providers';

export type DossierDocumentsValidationDocumentStatusProps = {
    statusId: number;
    onAcceptDocument: () => void;
    onDenyDocument: () => void;
    isSubmitting: boolean;
};

const DossierDocumentsValidationDocumentStatus: React.FunctionComponent<DossierDocumentsValidationDocumentStatusProps> =
    function (props) {
        const { statusId, onAcceptDocument, onDenyDocument, isSubmitting = false } = props;
        const { palette } = useTheme();

        const iconSx = {
            lineHeight: 0,
            display: 'flex',
            alignItems: 'center',
            fontSize: '14px',
            transition: 'color 0.25s ease',
        };

        const cancelBtnSx = {
            display: 'flex',
            alignItems: 'center',
            gap: '0 8px',
            color: palette.secondary.dark,
            ':hover': {
                color: palette.secondary.main,
            },
        };

        const cancelIconSx = {
            ...iconSx,
        };

        const validBtnSx = {
            display: 'flex',
            alignItems: 'center',
            gap: '0 8px',
            color: palette.primary.dark,
            ':hover': {
                color: palette.primary.main,
            },
        };

        const validIconSx = {
            ...iconSx,
        };

        const refused = statusId === STATUS_REFUSED;
        const accepted = statusId === STATUS_VALID;

        return (
            <>
                {!refused && (
                    <Button
                        sx={cancelBtnSx}
                        onClick={onDenyDocument}
                        disabled={isSubmitting}
                    >
                        <FaOptionIcon
                            sx={cancelIconSx}
                            icon={['fasl', 'circle-xmark']}
                        />
                        Refuser
                    </Button>
                )}
                {!accepted && (
                    <Button
                        sx={validBtnSx}
                        onClick={onAcceptDocument}
                        disabled={isSubmitting}
                    >
                        <FaOptionIcon
                            sx={validIconSx}
                            icon={['fasl', 'circle-check']}
                        />
                        Accepter
                    </Button>
                )}
            </>
        );
    };

export default DossierDocumentsValidationDocumentStatus;
